// Tati Rosales en Shopify. Lo que solo existe en la tienda. Reseñas en vivo de Judge.me,
// cantidad del formulario de compra, carrito y la zona para escribir reseñas.
// El resto (menú, galería, stickers, formulario) es sitio.js, el mismo de la web de Vercel.
(() => {
  const TIENDA = "1c3a3e-2.myshopify.com";
  const COLORES = ["", "nota--menta", "nota--oro", "nota--rosa", "nota--cielo"];
  const GIROS = ["-1.2deg", "0.9deg", "-0.4deg", "1.3deg", "-0.9deg", "0.5deg"];
  const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  const ESTRELLA = '<path fill="currentColor"%CLASE% d="M12 2.8l2.8 5.9 6.4.8-4.7 4.5 1.2 6.4L12 17.3l-5.7 3.1 1.2-6.4L2.8 9.5l6.4-.8z"/>';
  const VERIFICADA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M7.5 12.3l3 3 6-6.3"/></svg>';

  const esc = (t) => String(t == null ? "" : t).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;" })[c]);

  const estrellas = (n) => {
    const llenas = Math.round(Number(n));
    let fila = "";
    for (let i = 0; i < 5; i++) fila += '<svg viewBox="0 0 24 24" aria-hidden="true">' + ESTRELLA.replace("%CLASE%", i < llenas ? "" : ' class="apagada"') + "</svg>";
    return `<span class="estrellas__fila" role="img" aria-label="${String(n).replace(".", ",")} de 5 estrellas">${fila}</span>`;
  };

  // Momento de Judge.me como AAAA-MM-DDTHH:MM:SSZ en UTC (se ordena como texto y Safari lo entiende).
  // Viene como 2026-08-03T01:27:08Z o, en widgets más viejos, como 2026-08-03 01:27:08 UTC
  const momentoUtc = (t) => {
    const d = new Date(String(t || "").trim().replace(" UTC", "Z").replace(" ", "T"));
    return isNaN(d) ? "" : d.toISOString().replace(/\.\d{3}Z$/, "Z");
  };

  // Día de la reseña en hora de Chile, igual que fecha_corta() de generar.py. 2026-08-03T01:27:08Z
  // fue el 2 de agosto a las 21:27 en Chile y dice 2 ago 2026
  const DIA_CHILE = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Santiago", year: "numeric", month: "2-digit", day: "2-digit" });
  const fechaCorta = (iso) => {
    if (!iso) return "";
    let a, m, d;
    if (iso.includes("T")) {
      const partes = {};
      DIA_CHILE.formatToParts(new Date(iso)).forEach((p) => { partes[p.type] = p.value; });
      [a, m, d] = [partes.year, partes.month, partes.day];
    } else {
      [a, m, d] = iso.split("-");
    }
    return `${parseInt(d, 10)} ${MESES[parseInt(m, 10) - 1]} ${a}`;
  };

  // Igual que nota_resena() de generar.py
  const nota = (r, i, oculta) => {
    const parrafos = r.texto.map((t) => `<p>${esc(t)}</p>`).join("");
    const titulo = r.titulo ? `<h3>${esc(r.titulo)}</h3>` : '<h3 class="visualmente-oculto">Reseña</h3>';
    const fotos = r.fotos.slice(0, 1).map((u) => `<figure class="nota__foto"><img src="${esc(u.replace("width=1024", "width=640"))}" alt="Foto que subió ${esc(r.autor)} con su reseña" width="640" height="480" loading="lazy" decoding="async"></figure>`).join("");
    const verificada = r.verificada ? `<span class="verificada">${VERIFICADA} Compra verificada</span>` : "";
    return `<article class="nota ${COLORES[i % COLORES.length]}" style="--r:${GIROS[i % GIROS.length]}"${oculta ? " hidden data-resena-oculta" : ""}>
  ${estrellas(r.nota)}
  ${titulo}
  ${parrafos}${fotos}
  <div class="nota__autor"><span class="nota__inicial" aria-hidden="true">${esc(r.autor.slice(0, 1).toUpperCase())}</span><span>${esc(r.autor)}<br>${verificada}</span><span class="nota__fecha">${fechaCorta(r.fecha)}</span></div>
</article>`;
  };

  // Igual que _parsear_resenas() de generar.py. Primero más estrellas, dentro de cada grupo la más reciente
  const parsear = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const revs = [...doc.querySelectorAll(".jdgm-rev")].map((el) => {
      const cuerpo = el.querySelector(".jdgm-rev__body");
      let texto = cuerpo ? [...cuerpo.querySelectorAll("p")].map((p) => p.textContent.trim()) : [];
      if (!texto.length && cuerpo) texto = [cuerpo.textContent.trim()];
      const puntaje = el.querySelector("[data-score]");
      // El momento viene en time datetime o, en widgets más viejos, en jdgm-rev__timestamp data-content
      const fecha = el.querySelector("time[datetime]");
      const marca = el.querySelector(".jdgm-rev__timestamp[data-content]");
      return {
        autor: ((el.querySelector(".jdgm-rev__author") || {}).textContent || "").trim(),
        nota: parseInt(puntaje ? puntaje.getAttribute("data-score") : "0", 10) || 0,
        titulo: ((el.querySelector(".jdgm-rev__title") || {}).textContent || "").trim(),
        texto: texto.filter(Boolean),
        fecha: fecha ? momentoUtc(fecha.getAttribute("datetime")) : marca ? momentoUtc(marca.getAttribute("data-content")) : "",
        verificada: el.getAttribute("data-verified-buyer") === "true",
        fotos: [...el.querySelectorAll(".jdgm-rev__pics [data-mfp-src]")].map((a) => a.getAttribute("data-mfp-src")),
      };
    });
    const vistas = new Set();
    const unicas = revs.filter((r) => {
      const clave = [r.autor, r.fecha, r.titulo, r.texto.join(" ")].join("|");
      if (vistas.has(clave)) return false;
      vistas.add(clave);
      return true;
    });
    return unicas.sort((a, b) => (b.nota - a.nota) || (a.fecha < b.fecha ? 1 : a.fecha > b.fecha ? -1 : 0));
  };

  // Judge.me entrega las reseñas por páginas. Con per_page=100 corta antes del total (el libro dio 28
  // de 54 el 17-10), así que se piden de a 10 y se completan las páginas que indica total_count
  const POR_PAGINA = 10;
  const MAX_PAGINAS = 50;
  // Con tiempo límite, así una página que no responde cae en el catch y se muestran las demás
  const limite = () => (typeof AbortSignal !== "undefined" && AbortSignal.timeout ? { signal: AbortSignal.timeout(10000) } : {});
  const pedirPagina = (id, pagina) => fetch(`https://judge.me/reviews/reviews_for_widget?url=${TIENDA}&shop_domain=${TIENDA}&platform=shopify&page=${pagina}&per_page=${POR_PAGINA}&product_id=${id}`, limite())
    .then((r) => (r.ok ? r.json() : Promise.reject(r.status)));
  const cache = {};
  const traer = (id) => {
    if (!cache[id]) {
      cache[id] = pedirPagina(id, 1).then((d) => {
        const paginas = Math.min(Math.ceil((d.total_count || 0) / POR_PAGINA), MAX_PAGINAS);
        const resto = [];
        // Si una página falla se muestran las demás, en vez de volver a las 5 del widget guardado
        for (let n = 2; n <= paginas; n++) resto.push(pedirPagina(id, n).then((x) => x.html || "").catch(() => ""));
        return Promise.all(resto).then((htmls) => parsear([d.html || "", ...htmls].join("")));
      });
    }
    return cache[id];
  };

  // Muros con reseñas elegidas (inicio y Mira tu caca)
  document.querySelectorAll("template[data-resenas-muro]").forEach((t) => {
    const muro = t.parentElement;
    const autores = (t.dataset.autores || "").split("|").filter(Boolean);
    const desde = parseInt(t.dataset.desde || "0", 10);
    traer(t.dataset.productoId).then((revs) => {
      const elegidas = [];
      autores.forEach((a) => { const r = revs.find((x) => x.autor === a); if (r) elegidas.push(r); });
      if (!elegidas.length) return;
      elegidas.sort((a, b) => (b.nota - a.nota) || (a.fecha < b.fecha ? 1 : a.fecha > b.fecha ? -1 : 0));
      muro.querySelectorAll(".nota").forEach((n) => n.remove());
      muro.insertAdjacentHTML("beforeend", elegidas.map((r, i) => nota(r, i + desde)).join(""));
    }).catch(() => { /* quedan las del widget guardado */ });
  });

  // Todas las reseñas en la ficha, de a 6
  document.querySelectorAll("[data-resenas-ficha]").forEach((muro) => {
    traer(muro.dataset.productoId).then((revs) => {
      if (!revs.length) return;
      muro.innerHTML = revs.map((r, i) => nota(r, i, i >= 6)).join("");
      const antes = muro.parentElement.querySelector(".mas-resenas");
      if (antes) antes.remove();
      if (revs.length <= 6) return;
      muro.insertAdjacentHTML("afterend", '<div class="mas-resenas"><button class="boton boton--claro" type="button" data-mas-resenas-vivo>Ver más reseñas</button></div>');
      const boton = muro.parentElement.querySelector("[data-mas-resenas-vivo]");
      boton.addEventListener("click", () => {
        muro.querySelectorAll("[data-resena-oculta]").forEach((n) => { n.hidden = false; });
        boton.closest(".mas-resenas").remove();
      });
    }).catch(() => { /* quedan las del widget guardado */ });
  });

  // Escribir reseña abre el widget de Judge.me que vive escondido bajo las reseñas y aprieta su
  // botón "Escribir una reseña" para dejar el formulario a la vista
  document.querySelectorAll("[data-escribir-resena]").forEach((b) => b.addEventListener("click", () => {
    const zona = document.getElementById("escribir-resena");
    if (!zona) return;
    zona.classList.add("abierta");
    let intentos = 0;
    const buscar = () => {
      const boton = [...zona.querySelectorAll("button, a, [role=button]")].find((x) => /escribir una rese/i.test(x.textContent || ""));
      if (boton) { boton.click(); return; }
      if (++intentos < 20) setTimeout(buscar, 200);
    };
    setTimeout(buscar, 150);
  }));

  const acotar = (input, minimo) => {
    const n = Math.max(minimo, Math.min(99, parseInt(input.value, 10) || 0));
    input.value = n;
    return n;
  };

  // Cantidad del formulario de compra
  document.querySelectorAll("[data-compra-form]").forEach((form) => {
    const input = form.querySelector("input[name=quantity]");
    if (!input) return;
    form.querySelectorAll("[data-paso]").forEach((b) => b.addEventListener("click", () => {
      input.value = (parseInt(input.value, 10) || 1) + Number(b.dataset.paso);
      acotar(input, 1);
    }));
    input.addEventListener("change", () => acotar(input, 1));
  });

  // Carrito. Cambiar una cantidad actualiza el carrito al tiro
  document.querySelectorAll("[data-carrito]").forEach((form) => {
    const actualizar = form.querySelector("[data-actualizar]");
    const enviar = () => (form.requestSubmit ? form.requestSubmit(actualizar) : actualizar.click());
    form.querySelectorAll(".cantidad").forEach((caja) => {
      const input = caja.querySelector("input");
      caja.querySelectorAll("[data-paso]").forEach((b) => b.addEventListener("click", () => {
        input.value = (parseInt(input.value, 10) || 0) + Number(b.dataset.paso);
        acotar(input, 0);
        enviar();
      }));
      input.addEventListener("change", () => { acotar(input, 0); enviar(); });
    });
  });

  // Precios de la app Selleasy. Los pinta con el formato de su propia configuración ($11,990) y
  // trae el monto en default-price. Se muestran en pesos chilenos con punto de miles, igual que el
  // resto de la tienda ($11.990). Solo cuando la moneda a la vista es CLP
  const monedaClp = () => !(window.Shopify && Shopify.currency && Shopify.currency.active) || Shopify.currency.active === "CLP";
  const clp = (n) => "$" + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const ajustarPrecios = () => {
    if (!monedaClp()) return;
    document.querySelectorAll("[class*='lb-upsell-money'][default-price]").forEach((el) => {
      const n = parseFloat(el.getAttribute("default-price"));
      if (!Number.isFinite(n)) return;
      const texto = clp(n);
      if (el.textContent !== texto) el.textContent = texto;
    });
  };
  let pendiente = false;
  new MutationObserver(() => {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(() => { pendiente = false; ajustarPrecios(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  ajustarPrecios();

  // El sticker del menú del teléfono es loading="lazy", pero el menú cerrado está en pantalla
  // (solo invisible) y el navegador lo bajaría igual. Hasta la primera vez que se abre queda fuera
  // del dibujo (tema.css) y ahí el navegador recién lo baja
  const abrirMenu = document.querySelector("[data-abrir-menu]");
  const menuMovil = document.getElementById("menu-movil");
  if (abrirMenu && menuMovil) abrirMenu.addEventListener("click", () => menuMovil.setAttribute("data-abierto-una-vez", ""), { once: true });
})();
